<h2 mat-dialog-title>Conteúdo do Curriculo</h2>
<mat-dialog-content>
    <h3>
        Verifique se o conteúdo do seu curriculo esta legivel (contem espaços ou pontuação como no arquivo enviado),
        caso não estiver você pode enviar outro
    </h3>

    <form [formGroup]="form">
        <div class="row">
            <mat-form-field appearance="outline">
                <textarea id="textareaCurriculoContent" matInput formControlName="content" [cdkTextareaAutosize]="true"
                    (paste)="onPaste($event)"></textarea>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-progress-bar *ngIf="submiting" mode="indeterminate!"></mat-progress-bar>
<mat-dialog-actions [ngStyle]="{flexDirection: 'row-reverse'}" *ngIf="!submiting">
    <button mat-raised-button color="primary" (click)="onSubmit()">Continuar</button>
</mat-dialog-actions>